export class Price {
  public amount: number;
  public currency: string;

  constructor( amount: number, currency: string = 'EUR' ) {
    this.amount = amount;
    this.currency = currency;
  }
  
}